import { initializeApp, type FirebaseApp } from "firebase/app";
import { getAuth, type Auth } from "firebase/auth";

const firebaseConfig = {
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY,
  authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN,
  projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID,
  storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID,
  appId: import.meta.env.VITE_FIREBASE_APP_ID,
  measurementId: import.meta.env.VITE_FIREBASE_MEASUREMENT_ID,
};

const requiredFirebaseConfig = [
  ["VITE_FIREBASE_API_KEY", firebaseConfig.apiKey],
  ["VITE_FIREBASE_AUTH_DOMAIN", firebaseConfig.authDomain],
  ["VITE_FIREBASE_PROJECT_ID", firebaseConfig.projectId],
  ["VITE_FIREBASE_STORAGE_BUCKET", firebaseConfig.storageBucket],
  ["VITE_FIREBASE_MESSAGING_SENDER_ID", firebaseConfig.messagingSenderId],
  ["VITE_FIREBASE_APP_ID", firebaseConfig.appId],
] as const;

const missing = requiredFirebaseConfig
  .filter(([, value]) => !value || String(value).includes("replace_me") || String(value).includes("your-project"))
  .map(([name]) => name);

if (missing.length > 0) {
  throw new Error(
    `Firebase config is missing/placeholder for: ${missing.join(", ")}. Set real values in frontend/.env.local and restart Vite.`,
  );
}

if (!/^AIza[0-9A-Za-z_-]{20,}$/.test(String(firebaseConfig.apiKey ?? ""))) {
  throw new Error(
    "Firebase API key format is invalid in frontend/.env.local (VITE_FIREBASE_API_KEY).",
  );
}

if (!/^\d{1,}:\d{1,}:web:[0-9a-f]{10,}$/i.test(String(firebaseConfig.appId ?? ""))) {
  throw new Error(
    "Firebase app id format is invalid in frontend/.env.local (VITE_FIREBASE_APP_ID).",
  );
}

export const firebaseApp: FirebaseApp = initializeApp(firebaseConfig);
export const auth: Auth = getAuth(firebaseApp);
